module.exports = __webpack_public_path__ + "static/z6g_mobile-88e2618d6ceff1b0b05aee6692bfd631.jpg";